<div class="footer-container">
    <p>© {{d}} Sinigual. Todos los derechos reservados.</p>
    <div class="right-footer-contents">
        <p> Versión {{version}}</p>
        <!--<app-text-with-link [value]="privacity" [color]="'var(--t2)'"></app-text-with-link>
        <app-text-with-link [value]="terms_conditions" [color]="'var(--t2)'"></app-text-with-link>
        <app-text-with-link [value]="advice" [color]="'var(--t2)'"></app-text-with-link>-->
    </div>
</div>